import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useFormik } from 'formik'
import { requestPassword } from '../core/_requests'

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .matches(
      // eslint-disable-next-line
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Bitte geben Sie eine E-Mail-Adresse im richtigen Format ein'
    )
    .required('Pflichtfeld'),
})

const initialValues = {
  email: '', //post@kevinbrumme.de
}

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)

      let message = 'Bei der Datenverarbeitung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.'

      try {
        const { error, data } = await requestPassword(values.email)
        console.log(data, error?.status);
        if (error?.status === 429) {
          setStatus('Sie können alle 60 Sekunden eine E-Mail senden')
        } else {
          setStatus('Es ist ein Fehler aufgetreten')
        }

        setSubmitting(false)
        setLoading(false)

      } catch (error) {
        setStatus(message)
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  return (
    <form
      className='form w-100'
      noValidate
      id='kt_login_password_reset_form'
      onSubmit={formik.handleSubmit}
    >
      {/* begin::Heading */}
      <div className='mt-lg-8 mb-8'>
        <img
          alt='Logo'
          className='h-40px logo theme-light-show mb-3 me-4'
          src={toAbsoluteUrl('/media/logos/favicon_partnerportal.png')}
        />
        <img
          alt='Logo'
          className='h-55px logo theme-light-show'
          src={toAbsoluteUrl('/media/logos/ofindo_logo_partnerportal.svg')}
        />
        <img
          alt='Logo'
          className='h-40px logo theme-dark-show mb-3 me-4'
          src={toAbsoluteUrl('/media/logos/favicon_partnerportal.png')}
        />
        <img
          alt='Logo'
          className='h-55px logo theme-dark-show'
          src={toAbsoluteUrl('/media/logos/ofindo_logo_partnerportal.svg')}
        />
      </div>
      {/* begin::Heading */}
      <div className='mb-8'>
        {/* begin::Title */}
        <h1 className='text-dark fw-bolder mb-3'>Passwort vergessen?</h1>
        {/* end::Title */}

        {/* begin::Link */}
        <div className='text-gray-500 fw-semibold fs-6'>
          Wir senden Ihnen einen Wiederherstellungslink an die folgende E-Mail-Adresse
        </div>
        {/* end::Link */}
      </div>

      {
        formik.status && (
          <div className='alert alert-danger'>
            <div className='alert-text font-weight-bold'>{formik.status}</div>
          </div>
        )
      }

      {/* end::Title */}

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-label fw-bolder text-gray-900 fs-6'>E-Mail-Adresse</label>
        <input
          type='email'
          placeholder=''
          autoComplete='off'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            { 'is-invalid': formik.touched.email && formik.errors.email },
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='d-grid mb-5'>
        <button
          type='submit'
          id='kt_password_reset_submit'
          className='btn btn-primary'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>E-Mail senden</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Wird geladen ...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      <div className='separator separator-content my-10'>
        <span className='w-50px text-gray-500 fw-semibold fs-7'>oder</span>
      </div>
      <Link to='/auth/login'>
        <button
          type='button'
          id='kt_login_password_reset_form_cancel_button'
          className='btn btn-light-primary w-100'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          Anmelden
        </button>
      </Link>
      {/* end::Form group */}
    </form>
  )
}
